import $ from "jquery";
import new_map from "./map";

let regionFieldSelectValue;
let $storeFields = $(".search__stores");
let $storeField;
let storeField;
const spinner = $(".pizzeria-search__spinner");

// $(".search__regions select").on("change", function() {
//   $storeFields.removeClass("active");
//   regionFieldSelectValue = $(this).val();
//   storeField = `.search__stores.${regionFieldSelectValue}`;
//   $storeField = $(storeField);
//   $storeField.addClass("active");
// });

$(".search__regions select").change(function(e) {
  $storeFields.removeClass("active");
  regionFieldSelectValue = $(e.target).val();
  storeField = ".search__stores." + regionFieldSelectValue;
  $storeField = $(storeField);
  $storeField.addClass("active");
});

$(".search__stores-go").on("click", function() {
  let storeFieldSelect = storeField + " select";
  let storeFieldSelectValue = $(storeFieldSelect).val();
  if (typeof storeFieldSelectValue !== "undefined") {
    spinner.addClass("active");
    $(".pizzeria-list li").remove();

    $("#ajax-pizzeria").load(
      "/pizzerias/" + storeFieldSelectValue + " #pizzeria",
      function() {
        $(".acf-map").each(function() {
          new_map($(this));
          spinner.removeClass("active");
        });
        document.querySelector("#ajax-pizzeria").scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    );
  }
});

$(".pizzeria-list").on("click", ".pizzeria-list__item", function() {
  let slug = $(this).data("pizzeria");
  spinner.addClass("active");
  $(".pizzeria-list li").remove();
  $("#ajax-pizzeria").load("/pizzerias/" + slug + " #pizzeria", function() {
    $(".acf-map").each(function() {
      new_map($(this));
      spinner.removeClass("active");
    });
  });
});



// WEBPACK FOOTER //
// ./assets/js/components/pizzeria-search-selects.js